
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lp",
      function () {
        return require("private-next-pages/lp/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lp"])
      });
    }
  